<template>
  <div class="fix-width-container chronology">
    <!-- 全局搜索框 -->
    <searchComponent ref="searchComponent" />

    <!-- 年份选择区域 -->
    <el-radio-group
      v-model="choosedYear"
      class="margin-top20 year-radio-group"
      @change="setHasDataMonth"
    >
      <el-radio
        v-for="item in allYears"
        :key="item"
        :label="item"
        :disabled="hasDataYears.indexOf(item) === -1"
      />
    </el-radio-group>

    <!-- 主要内容区 -->
    <div 
      v-loading="loading"
      class="main-content margin-top16"
    >
      <!-- 左侧月份选择 -->
      <div class="left-nav">
        <el-radio-group
          v-model="choosedMonth"
          @change="setHasDataDays"
        >
          <el-radio
            v-for="i in 12"
            :key="i"
            :label="i"
            :disabled="hasDataMonths.indexOf(i) === -1"
          >
            {{ choosedYear }}.{{ formatDD(i) }}
          </el-radio>
        </el-radio-group>

        <el-button
          :disabled="choosedYear === hasDataYears[0]"
          type="text"
          class="pager"
          @click="changeYear(-1)"
        >上一页</el-button>
        <el-button
          :disabled="choosedYear === hasDataYears[hasDataYears.length - 1]"
          type="text"
          class="pager"
           @click="changeYear(1)"
        >下一页</el-button>
      </div>

      <!-- 右侧日期选择及跳转 -->
      <div class="right-choose">
        <div>
          <day-picker
            ref="dayPicker"
            :year="choosedYear"
            :month="choosedMonth"
            :isDisabledDate="setDisableDate"
            @dateChange="dateChange"
          />
        </div>

        <i 
          class="router-icon nuncupation-icon margin-top24 pointer"
          @click="toLib('http://www.reformdata.org/orh/')"
        />
        <i
          class="router-icon object-icon margin-top16 pointer"
          @click="toLib('http://www.reformdata.org/rhn/')"
        />
      </div>

      <!-- 数据结果区 -->
      <div class="data-content">

        <div class="margin-bottom24">
          <span class="title-text">{{ showDate }}</span>
          <span class="float-right margin-right32">
            <span class="title-text">共计</span>
            <span class="count-text">{{ resultData.length }}</span>
            <span class="title-text">条</span>
          </span>
        </div>

        <ul class="result-data">
          <li
            v-for="(item, index) in resultData"
            :key="index"
            class="data-item"
          >
            <span class="day-icon">{{ item.day }}日</span>
            <i class="circle-icon"></i>
            <div class="data-item-content">
              <h3 
                class="title-text pointer"
              >
                <locked-item 
                  :locked="item.locked"
                  @toDetail="toDetail(item.id)"
                >
                  <template slot="title">
                    {{ item.title }} 
                  </template>
                </locked-item>
              </h3>               
              <div v-if="item.imgUrl">
                <img 
                  class="img-conatiner margin-top16" 
                  :src="item.imgUrl" 
                  :class="setImgWidth(index)"
                  :style="{height: mapHeight[index]}"
                />
              </div>            
              <p class="content-text margin-top16 text-indent">{{ item.content }}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="clearfix"></div>
    </div>

  </div>
</template>

<script>
// components
import searchComponent from '@/components/searchComponent'
import dayPicker from '@/components/dayPicker'
import lockedItem from '@/modules/common/lockedItem.vue'

// dataRequest
import {annalisticService} from '@/service/httpService'

export default {
  components: {
    searchComponent,
    dayPicker,
    lockedItem
  },
  data () {
    return {
      // 年份选择
      choosedYear: null,
      allYears: window.dictionaryConfig.chronologyYears,
      hasDataYears: [],

      // 月份选择
      choosedMonth: null,
      hasDataMonths: [],

      // 日期选择
      choosedDate: null,
      hasDataDays: [],

      // 结果数据
      resultData: [],
      showDate: '',
      loading: false,

      // 节流用
      timer: null,

      // 一个对象 用来保存图片
      mapHeight: {}
    }
  },
  mounted () {
    this.setHasDataYear()
  },
  methods: {
    // 图片定宽，高度按原图比例缩放
    setImgWidth(index) {
      var img = document.querySelector(`.img-conatiner${index}`)
      if (img) {
        img.onload = () => {
          const naturalWidth = img.naturalWidth
          const naturalHeight = img.naturalHeight
          this.$set(this.mapHeight, index, naturalHeight*540/naturalWidth + 'px')
        }
      }
      return `img-conatiner${index}`
    },

    // 格式化 DD 格式
    formatDD (val) {
      return ('0' + val).substr(-2, 2)
    },

    // get HasCountArray
    getHasCountArray (data, key) {
      let dist = []
      data.forEach(item => {
        if (item.Count) {
          dist.push(item[key])
        }
      })
      return dist 
    },

    // 函数节流
    reduceRequest (fn) {
      clearTimeout(this.timer)
      this.timer = setTimeout(fn, 600)
    },

    // 上侧年份的数量统计，没有数据的年份不可点击
    setHasDataYear () {
      annalisticService.getYearCount().then(res => {
        this.hasDataYears = this.getHasCountArray(res.data, 'Year')
        const queryYear = parseInt(this.$route.query.year)
        // 如果查询具体年份，并且该年份有数据
        if (queryYear && this.hasDataYears.indexOf(queryYear) !== -1) {
          this.choosedYear = parseInt(queryYear)
        } else {
          this.choosedYear = this.hasDataYears[0]
        }
      })        
    },

    // 统计当年有数据的月份
    setHasDataMonth (val) {
      this.reduceRequest(() => {
        this.loading = true
        annalisticService.getMonthCount({
        year: val
        }).then(res => {
          this.hasDataMonths =  this.getHasCountArray(res.data, 'Month')
          this.choosedMonth = this.hasDataMonths[0]

          // 有时候年份变化 但是对应的月份却并没有变化，还是要加载有数据的日期
          this.setHasDataDays(this.choosedMonth)
        })
      })     
    },

    // 左侧导航方法
    // 切换上一页，下一页
    changeYear (number) {
      for (let i = 0; i < this.hasDataYears.length; i++) {
        if (this.hasDataYears[i] === this.choosedYear) {
          this.choosedYear = this.hasDataYears[i + number]
          return true
        }
      }

    },
    // 统计当月有数据的日期
    setHasDataDays (val) {
      // 月份变化 清除日期
      this.$refs.dayPicker.clearDate()
      this.reduceRequest(() => {
        annalisticService.getDayCount({
          year: this.choosedYear,
          month: val
        })
        .then(res => {
          this.hasDataDays = this.getHasCountArray(res.data, 'Day')
        })
      })
    },

    // 主要内容区域
    loadListData (val) {
      this.loading = true
      annalisticService.getList({
        year: this.choosedYear,
        month: this.choosedMonth,
        day: this.choosedDate
      }).then(res => {
        let dist = []
        res.data.forEach(item => {
          dist.push({
            title: item.Title,
            imgUrl: item.headImageStoreId ?  window.dataUrl.TopicManage.downloadImage + item.headImageStoreId : '',
            id: item.Id,
            locked: item.Locked,
            day: window.moment(item.PublishTime).format('YYYY-MM-DD').substr(-2, 2),
            content: item.Summary
          })
        }) 
        this.loading = false
        this.resultData = dist
        //  防止时间顺便但数据还没加载带来不好的效果
        this.showDate = `${this.choosedYear}年${this.formatDD(this.choosedMonth)}月`
                        +`${this.choosedDate ? this.formatDD(this.choosedDate) + '日' : ''}`
      }, 
      () => {
        this.loading = false
      })
    },
    toDetail (id) {
      const {href} = this.$router.resolve({
        path: `/article/${id}`,
      })
      window.open(href)
    },

    // 右侧时间设置 和库跳转设置
    setDisableDate (date) {
      return !!date && this.hasDataDays.indexOf(date) === -1
    },
    dateChange (val) {
      this.choosedDate = val
      this.loadListData()
    },
    toLib (path) {
      this.$refs.searchComponent.toLib(path)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/chronology-out/chronology.vue